import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { RegistrationService } from '../../../../../lib/src/api/services';
import { AccountService, ProgressSpinnerService } from '../../../../../lib/src/public-api';
import { SurveyConfigService } from '../../services/survey-config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'competition-year',
  templateUrl: './competition-year.component.html',
  styleUrls: ['./competition-year.component.scss'],
  standalone: false,
})
export class CompetitionYearComponent implements OnInit {
  email = '';
  pin = '';
  isLegalAccepted = false;
  legalIsBlocking = false;

  // Dynamic properties based on survey type
  surveyId: number;
  surveyYear: number;
  isCurrentYear: boolean;

  token = '';
  stopSubscription$ = new Subject();

  constructor(
    private accountService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private registrationService: RegistrationService,
    private progressSpinnerService: ProgressSpinnerService,
    private messageService: MessageService,
    public surveyConfig: SurveyConfigService,
    public translateService: TranslateService,
  ) {}

  ngOnInit() {
    // Determine which survey year based on route
    this.route.data.subscribe((data) => {
      this.isCurrentYear = data['isCurrentYear'] ?? true;

      if (this.isCurrentYear) {
        this.surveyId = this.surveyConfig.currentYearSurveyId;
        this.surveyYear = this.surveyConfig.currentYear;
      } else {
        this.surveyId = this.surveyConfig.previousYearSurveyId;
        this.surveyYear = this.surveyConfig.previousYear;
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: any) {
    if (event.keyCode === 39) {
      this.buttonStartClicked();
    }
  }

  buttonStartClicked() {
    const user = this.accountService.getUser();
    const selectedSurvey = user.surveys.find((s) => s.surveyId === this.surveyId);

    if (!selectedSurvey) {
      return;
    }

    this.accountService.setCurrentSurveyInstance(selectedSurvey.surveyInstanceId);

    if (selectedSurvey.isSurveyFinished) {
      this.router.navigateByUrl(`end-of-survey/${selectedSurvey.surveyToken}`);
    } else {
      this.router.navigateByUrl(`surveys/${selectedSurvey.surveyToken}`);
    }
  }
}
